import React, { useEffect, useRef, useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";

/**
 * 대화 내보내기 진행 표시 (카톡 PC 처럼, 2026-10-15) — 공통 팝업(showPopupModal) 안에 들어간다.
 * 진행률은 읽어 온 턴 수 / 대화방 전체 턴 수. 다 되면 "완료되었습니다.", 실패하면 그 이유.
 * [폴더열기]는 없다 — 브라우저는 내 PC 폴더를 열 수 없다. 내려받은 파일은 브라우저 다운로드 표시에서 연다.
 */
export function ChatExportProgress({
  run,
}: {
  /** 내보내기 본체. 읽을 때마다 onProgress(읽은 턴, 전체 턴)을 부른다. 실패하면 던진다 */
  run: (onProgress: (done: number, total: number) => void) => Promise<void>;
}) {
  const [percent, setPercent] = useState(0);
  const [status, setStatus] = useState<"RUNNING" | "DONE" | "FAILED">("RUNNING");
  const [failure, setFailure] = useState("");
  /* 개발 모드에서 효과가 두 번 돌아도 한 번만 내보낸다 */
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    run((done, total) => {
      setPercent(total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0);
    })
      .then(() => {
        setPercent(100);
        setStatus("DONE");
      })
      .catch((err: unknown) => {
        setFailure(err instanceof Error && err.message ? err.message : "대화를 내보내지 못했습니다.");
        setStatus("FAILED");
      });
  }, [run]);

  return (
    <div className="chatbot-export-progress">
      <LinearProgress
        variant="determinate"
        value={status === "FAILED" ? 0 : percent}
        color={status === "FAILED" ? "error" : "primary"}
        sx={{ height: 10, borderRadius: 5 }}
      />
      <div className="chatbot-export-progress-percent">{status === "FAILED" ? "" : `${percent}%`}</div>
      <div className="chatbot-export-progress-text">
        {status === "RUNNING" && "대화를 내보내는 중입니다."}
        {status === "DONE" && "완료되었습니다."}
        {status === "FAILED" && failure}
      </div>
    </div>
  );
}
